module.exports = ".opciones-list {\n  margin-top: 16px;\n  width: 100%; }\n"